import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20background%20with%20soft%20terracotta%20and%20sage%20green%20tones%2C%20subtle%20geometric%20patterns%2C%20clean%20modern%20aesthetic%2C%20editorial%20product%20showcase%20backdrop%2C%20soft%20lighting%2C%20harmonious%20composition%2C%20elegant%20European%20design%20style%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet Polska"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <p className="text-sm md:text-base text-white/80 font-medium tracking-wide uppercase mb-4">
          Kakobuy Spreadsheet Polska
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
          {t('hero.h1')}
        </h1>
        <p className="text-lg md:text-xl text-white/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-6 py-3 md:px-8 md:py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm md:text-base rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
          >
            {t('hero.ctaMain')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-6 py-3 md:px-8 md:py-3.5 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm font-semibold text-sm md:text-base border border-white/30 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer no-underline"
          >
            {t('hero.ctaSecondary')}
          </a>
        </div>
      </div>
    </section>
  );
}